<top-banner variant="custom">
    <h2 class="title mb-3" *ngIf="selectedContractor">{{ selectedContractor.name }}</h2>
    <button type="button" (click)="showCreateProcedureModal()" class="btn color_blue-btn btn-round">
      <i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE OEM PROCEDURE</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <h4 class="card-title">Procedures</h4>
            <div class="mb-2 animated fadeIn">
              <div class="row">
                <div class="col-md-12">
                  <div class="filter-flex-row">
                    <div>
                      <label>ID:</label>
                      <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'idFilter')"></text-filter-box>
                    </div>
                    <div>
                      <label>Name/Code:</label>
                      <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'nameFilter')"></text-filter-box>
                    </div>
                    <div>
                      <label>Description:</label>
                      <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'descriptionFilter')"></text-filter-box>
                    </div>
                    <div *ngIf="isFilterLoading" class="small-spinner">
                      <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                    </div>
                  </div>
                  <br>
                </div>
              </div>
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table
                      [resizableColumns]="true"
                      [autoLayout]="true"
                      [value]="procedures"
                      selectionMode="single"
                      [(selection)]="selectedProcedure"
                      (onRowSelect)="onRowSelect($event)"
                      (onSort)="customSort($event)"
                      [sortField]="defaultSortField"
                      [lazy]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th [pSortableColumn]="'id'">ID
                          <p-sortIcon [field]="'id'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'name'">Name/Code
                          <p-sortIcon [field]="'name'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'description'">Description
                          <p-sortIcon [field]="'description'"></p-sortIcon>
                        </th>
                        <th>Revision</th>
                        <th>Minimum Work Party Size</th>
                        <th [pSortableColumn]="'assetCategory.name'">Asset Category
                          <p-sortIcon [field]="'assetCategory.name'"></p-sortIcon>
                        </th>
                        <th>Competencies</th>
                        <th>Created By</th>
                        <th [pSortableColumn]="'lastModifiedDate'">Last Updated
                          <p-sortIcon [field]="'lastModifiedDate'"></p-sortIcon>
                        </th>
                        <th>Pre-approved</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-procedure>
                      <tr [pSelectableRow]="procedure">
                        <td>PRC{{ procedure.id }}</td>
                        <td>{{ procedure.name }}</td>
                        <td>{{ procedure.description }}</td>
                        <td>{{ procedure.revision }}</td>
                        <td>{{ procedure.minimumPartySize }}</td>
                        <td>{{ procedure.assetCategory.name }}</td>
                        <td>
                          <span *ngFor="let competency of procedure.competencyTypes" class="badge badge-pill badge-warning">
                            <ng-container *ngIf="!competency.allWorkerRequired">
                              <i class="fas fa-user"></i>
                            </ng-container>
                            <ng-container *ngIf="competency.allWorkerRequired">
                              <i class="fas fa-users"></i>
                            </ng-container>
                            {{ competency | shortestName }}<br />
                          </span>
                        </td>
                        <td>{{ procedure.createdBy }}</td>
                        <td>{{ procedure.lastModifiedDate | date: 'E d MMM yyyy HH:mm' }}</td>
                        <td class="table-cell-centered">
                          <span *ngIf="procedure.preapproved === true"><i class="fas fa-check-circle success"></i></span>
                          <span *ngIf="procedure.preapproved === false"><i class="fas fa-times-circle danger"></i></span>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="9">No procedures found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator
                #paginator
                [rows]="pagination.size"
                [totalRecords]="pagination.totalRecords"
                [rowsPerPageOptions]="pageSizes"
                (onPageChange)="paginate($event)">
              </p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- view documents -->
<p-dialog header="Procedure Documents" [(visible)]="isViewProcedureDocumentsModalShown" modal="true" [dismissableMask]="true" [baseZIndex]="1000000">
  <div *ngIf="selectedProcedure?.files.length">
    <div class="row" *ngFor="let file of selectedProcedure?.files">
      <div class="col-md-12">
        <button class="btn btn-primary" (click)="viewDocument(file.fileName)">View {{ file.fileName }}</button>
        <button class="btn btn-danger" (click)="deleteDocument(file.id)">Delete {{ file.fileName }}</button>
      </div>
    </div>
  </div>
  <div *ngIf="!selectedProcedure?.files.length">
    <p>No documents attached to this procedure</p>
  </div>
</p-dialog>

<!-- Upload Additional Documents Files Dialog -->
<p-dialog [(visible)]="isAddDocumentsToProcedureModalShown">
  <p-header> Upload Procedure RAMS Files </p-header>
  <div *ngIf="!saveInProgress" class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label for="procedureDocuments" class="btn btn-primary btn-round">Choose Documents...</label>
        <input
          type="file"
          class="form-control"
          name="procedureDocuments"
          id="procedureDocuments"
          accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
          (change)="onFileChange($event)"
          multiple/>
        <ng-container *ngIf="selectedDocuments.length">
          <p>Selected Files:</p>
          <ul>
            <li *ngFor="let file of selectedDocuments">{{ file.name }}</li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <button type="button" class="btn btn-default-outline" (click)="isAddDocumentsToProcedureModalShown = false">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="saveInProgress" (click)="onAddDocumentsSubmit()">Upload</button>
  </p-footer>
</p-dialog>
